// extracted by mini-css-extract-plugin
export default {"header":"main_header__Rd5xg","main":"main_main__ks7t4"};